// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Float from "../../../../../../node_modules/rescript/lib/es6/belt_Float.js";
import * as Belt_Option from "../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Address$PorterinFeature from "../../../shared/core/domain/entities/Address.mjs";
import * as AssetStore$PorterinFeature from "../../../ui/assets/AssetStore.mjs";
import * as Requirement$PorterinFeature from "../../../shared/core/domain/entities/Requirement.mjs";
import * as SharedHelper$PorterinFeature from "../../../shared/core/helpers/SharedHelper.mjs";
import * as SpotEstimateStore$PorterinFeature from "../../../shared/core/constants/SpotEstimateStore.mjs";

var input_from_icon = {
  src: AssetStore$PorterinFeature.fromInput,
  width: 16.0,
  height: 16.0,
  alt: "From Address Icon"
};

var input_from_iconV1 = {
  path: AssetStore$PorterinFeature.fromInput,
  alt_text: "From Address Icon"
};

var input_to_icon = {
  path: AssetStore$PorterinFeature.dropPin,
  alt_text: "To Address Icon"
};

function prefillUserName(user) {
  if (user !== undefined) {
    return Belt_Option.getWithDefault(user.name, "");
  } else {
    return "";
  }
}

function prefillUserMobile(user) {
  if (user !== undefined) {
    return Belt_Option.getWithDefault(user.mobile, "");
  } else {
    return "";
  }
}

function prefillRequirementType(user) {
  if (user === undefined) {
    return ;
  }
  var req = user.requirement_type;
  if (req !== undefined) {
    return Requirement$PorterinFeature.getTypeFromAuthString(req);
  } else {
    return /* Personal */0;
  }
}

var location_denied_icon = {
  src: SpotEstimateStore$PorterinFeature.location_denied_icon_url,
  width: 158.0,
  height: 158.0,
  alt: SpotEstimateStore$PorterinFeature.location_denied_icon_alt
};

function prefillPickupAddress(query_params) {
  var match = SharedHelper$PorterinFeature.getPickupDetail(query_params);
  var fromAddressLng = match[2];
  var fromAddressLat = match[1];
  var fromAddressLandmark = match[0];
  if (fromAddressLandmark !== undefined && fromAddressLat !== undefined && fromAddressLng !== undefined) {
    return {
            landmark: fromAddressLandmark,
            location: {
              lat: Belt_Option.getWithDefault(Belt_Float.fromString(fromAddressLat), 0.0),
              lng: Belt_Option.getWithDefault(Belt_Float.fromString(fromAddressLng), 0.0)
            }
          };
  } else {
    return Address$PorterinFeature.initial_address(undefined);
  }
}

var commonAssetPath = "/assets/";

export {
  commonAssetPath ,
  input_from_icon ,
  input_from_iconV1 ,
  input_to_icon ,
  prefillUserName ,
  prefillUserMobile ,
  prefillRequirementType ,
  location_denied_icon ,
  prefillPickupAddress ,
}
/* SharedHelper-PorterinFeature Not a pure module */
